/**
 * 页面标题更新混入
 * 在页面显示时自动更新标题以匹配当前语言设置
 */
import { Debounce } from '@/utils/validate.js';

export default {
	onShow: Debounce(function() {
		// 获取App实例并调用标题更新方法
		const app = getApp();
		if (app && typeof app.updateCurrentPageTitle === 'function') {
			// 防抖函数会确保只执行最后一次调用
			app.updateCurrentPageTitle();
		}
	}) // 使用Debounce函数的默认延迟时间（500ms）
};